import SvgArrowLeft from '@img/icons/arrow-left.svg';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import DotPagination from '@stories/Components/Misc/DotPagination/DotPagination';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className, "data-item-amount": carousel.maxIndex + 1 > 6, "aria-label": props.paginationTitle },
        React.createElement(S.Button, { "aria-label": "Go to Previous Item", disabled: !props.wrap && carousel.activeIndex === 0, type: "button", onClick: (event) => {
                event.preventDefault();
                carousel.goToPrev(props.wrap);
            } },
            React.createElement(SvgArrowLeft, null)),
        React.createElement(DotPagination, { count: carousel.maxIndex + 1, onChange: (index) => carousel.goToIndex(index), value: carousel.activeIndex }),
        React.createElement(S.Button, { "aria-label": "Go to Next Item", disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex, type: "button", onClick: (event) => {
                event.preventDefault();
                carousel.goToNext(props.wrap);
            } },
            React.createElement(SvgArrowRight, null))));
});
Controls.displayName = 'Controls';
export default Controls;
